export const filterByAcceptanceCount = (data) =>
  data === 'Error'
    ? data
    : data.filter((house) => house.acceptanceAddressCount > 0);

export const groupByStreet = (data) => {
  if (data === 'Error') return data;

  const result = data.reduce((acc, house) => {
    if (house.acceptanceAddressCount > 0) {
      const { streetId, streetName } = house;

      if (!acc.has(streetId)) {
        acc.set(streetId, { name: streetName || 'Не указано', houses: [] });
      }

      acc.get(streetId).houses.push(house);
    }

    return acc;
  }, new Map());

  return Array.from(result.entries());
};

export const selectHouseIds = (data) => {
  if (data === 'Error') return data;

  return data.reduce((acc, house) => {
    if (house.acceptanceAddressCount > 0) {
      acc.push(house.id);
    }

    return acc;
  }, []);
};
